import { Link } from "react-router-dom";
import { useLang } from "../context/LangContext";
import { Seo } from "../components/Seo";
import { Reveal, Hairline } from "../components/motion";
import { PHOTOS, SITE } from "../lib/site";

const Paras = ({ items, delayBase = 0 }) =>
  items.map((p, i) => (
    <Reveal key={p.slice(0, 40)} delay={delayBase + i * 0.06}>
      <p className="text-sand text-lg leading-relaxed font-light">{p}</p>
    </Reveal>
  ));

const PullQuote = ({ children }) => (
  <Reveal>
    <blockquote className="border-l-2 border-gold pl-8 py-2 my-4">
      <p className="font-serif text-2xl md:text-3xl italic text-gold leading-snug">{children}</p>
    </blockquote>
  </Reveal>
);

export default function Historia() {
  const { t, path } = useLang();
  const s = t.story;

  return (
    <>
      <Seo title={s.metaTitle} description={s.metaDesc} pageKey="historia" />

      <section className="pt-28 pb-12 md:pt-40 md:pb-16 bg-ink">
        <div className="container-lux grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div className="lg:col-span-7">
            <Reveal><div className="overline mb-8">{s.overline}</div></Reveal>
            <Reveal delay={0.1}>
              <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.05] text-cream">{s.h1}</h1>
            </Reveal>
            <Hairline className="my-10 max-w-xs" delay={0.2} />
            <Reveal delay={0.2}>
              <p className="font-serif text-2xl md:text-3xl italic text-cream/90">{s.intro}</p>
            </Reveal>
          </div>
          <div className="lg:col-span-5">
            <Reveal delay={0.25}>
              <div className="relative max-w-sm mx-auto lg:mx-0">
                <div className="absolute -inset-4 border border-gold/20" />
                <img src={PHOTOS.toga} alt={SITE.name} className="relative w-full aspect-[4/5] object-cover object-[50%_20%] photo-warm" data-testid="story-portrait" />
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <section data-testid="story-body" className="pb-16 md:pb-24 bg-ink">
        <div className="container-lux max-w-3xl space-y-8">
          <Paras items={s.paras1} />
          <PullQuote>{s.quote1}</PullQuote>
          <Paras items={s.paras2} />
          <PullQuote>{s.quote2}</PullQuote>
          <Paras items={s.paras3} />
          <Reveal>
            <p className="font-serif text-xl md:text-2xl text-cream leading-relaxed pt-4">{s.closing}</p>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="pt-10 border-t border-gold/15 mt-12 flex flex-wrap items-center justify-between gap-6">
              <div>
                <div className="font-serif text-2xl text-cream">{SITE.name}</div>
                <div className="overline mt-2">{SITE.cedula}</div>
              </div>
              <Link to={`${path("home")}#contact`} data-testid="story-cta" className="btn-gold btn-caps">{s.cta}</Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
